<template>
    <div>
        <Card>
            <div class="card-list-heading">
                <h2 class="text-bold">{{ __('Shipments report') }}</h2>

                <div class="d-flex flex-wrap">
                    <button
                        @click="filterReport"
                        class="btn btn-md btn-primary mr-3"
                        type="button"
                    >
                        {{ __('Filter') }}
                    </button>

                    <button
                        @click="exportLoads"
                        class="btn btn-md btn-primary"
                        type="button"
                    >
                        {{ __('Export XLS') }}
                    </button>
                </div>
            </div>
            

            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-row-flex">
                        <span>
                            {{ __('Date from') }}
                        </span>
                        <DateTimePicker
                            :placeholder="__('Select date from')"
                            @change="formatDateFrom"
                            format="YYYY-MM-DD"
                            name="reportdatefrom"
                            type="date"
                            v-model="report.dateFrom"
                            value-type="format"
                        />
                    </div>

                    <div class="form-row-flex">
                        <span>
                            {{ __('Receipt doc.') }}
                        </span>
                        <Autocomplete
                            :fetch-callback="$api.autocomplete.shipmentReceiveDocuments"
                            :placeholder="__('Select receipt doc.')"
                            @selected="(item) => report.receiveDocument = item.value"
                            @input="(item) => report.receiveDocument = item.value"
                            params="title"
                            value-selector="label"
                        >
                            <div slot-scope="result">
                                {{ result.result.label }}
                            </div>
                        </Autocomplete>
                    </div>

                    <div class="form-row-flex">
                        <span>
                            {{ __('Sender') }}
                        </span>
                        <Autocomplete
                            :fetch-callback="$api.autocomplete.shipmentSender"
                            :placeholder="__('Select sender')"
                            @selected="(item) => report.senderCustomer = item.value"
                            @input="(item) => report.senderCustomer = item.value"
                            params="title"
                            value-selector="label"
                        >
                            <div slot-scope="result">
                                {{ result.result.label }}
                            </div>
                        </Autocomplete>
                    </div>                    

                    <div class="form-row-flex">
                        <span>
                            {{ __('Recipient') }}
                        </span>
                        <Autocomplete
                            :fetch-callback="$api.autocomplete.shipmentReceivers"
                            :placeholder="__('Select recipient')"
                            @selected="(item) => report.receiverCustomer = item.value"
                            @input="(item) => report.receiverCustomer = item.value"
                            params="title"
                            value-selector="label"
                        >
                            <div slot-scope="result">
                                {{ result.result.label }}
                            </div>
                        </Autocomplete>
                    </div>
                </div>


                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-row-flex">
                        <span>
                            {{ __('Date to') }}
                        </span>
                        <DateTimePicker
                            :placeholder="__('Select date to')"
                            @change="formatDateTo"
                            format="YYYY-MM-DD"
                            name="reportdateto"
                            type="date"
                            v-model="report.dateTo"
                            value-type="format"
                        />
                    </div>                

                    <div class="form-row-flex">
                        <span>
                            {{ __('Shipment') }}
                        </span>
                        <Autocomplete
                            :fetch-callback="$api.autocomplete.shipmentShipments"
                            :placeholder="__('Select shipment')"
                            @selected="(item) => report.shipment = item.value"
                            @input="(item) => report.shipment = item.value"
                            params="title"
                            value-selector="label"
                        >
                            <div slot-scope="result">
                                {{ result.result.label }}
                            </div>
                        </Autocomplete>
                    </div>

                    <div class="form-row-flex">
                        <span>
                            {{ __('Marking') }}
                        </span>
                        <FormInput
                            name="report_marking"
                            type="text"
                            :placeholder="__('Select marking')"
                            v-model="report.marking"
                        ></FormInput>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12 col-md-12 card-nopadding">
                    <wi-table
                        :default-params="{ sort: 'createdAt', order: 'desc'}"
                        :disable-pagination="false"
                        :disable-search="true"
                        :disableHeader="true"
                        :fetch-callback="fetch"

                    >
                        <wi-table-column field="id" sortable>#</wi-table-column>
                        <wi-table-column
                            class="text-nowrap"
                            field="receiveDocument"
                            sortable
                        >
                            {{ __('Receipt doc.') }}
                        </wi-table-column>
                        <wi-table-column field="shipment">{{ __('Load') }}</wi-table-column>
                        <wi-table-column field="shipmentSize">{{ __('Size') }}</wi-table-column>
                        <wi-table-column field="senderCustomer.label">{{ __('Sender') }}</wi-table-column>
                        <wi-table-column field="receiverCustomer.label">{{ __('Recipient') }}</wi-table-column>
                        <wi-table-column :render="dateFormat" field="receiveDate">{{ __('Date of arrival') }}</wi-table-column>
                        <wi-table-column field="weightNetto">{{ __('NETTO weight') }}</wi-table-column>
                        <wi-table-column field="weightBrutto">{{ __('BRUTTO weight') }}</wi-table-column>
                        <wi-table-column field="marking">{{ __('Marking') }}</wi-table-column>
                        <wi-table-column field="lotNo">{{ __('LotNo') }}</wi-table-column>
                        <wi-table-column field="stock">{{ __('Stock') }}</wi-table-column>
                    </wi-table>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>

import moment from 'moment'

export default {
  name: 'ReportLoads',

  data () {
    return {
      report: {
        dateFrom: null,
        dateTo: null,
        receiveDocument: null,
        shipment: null,
        senderCustomer: null,
        marking: null,
        receiverCustomer: null,
        payer: null
      }
    }
  },

  methods: {
    dateFormat (item) {
      return moment(item.receiveDate).format('YYYY-MM-DD')
    },

    formatDateFrom (date) {
      this.report.dateFrom = moment(date).format('YYYY-MM-DD')
      return this.report.dateFrom
    },

    formatDateTo (date) {
      this.report.dateTo = moment(date).format('YYYY-MM-DD')
      return this.report.dateTo
    },

    filterReport () {
      return this.$api.reports.shipment.list(this.report)
    },

    exportLoads () {
      return this.$api.reports.shipment.download(this.report)
    },

    fetch (params = []) {
      return this.$api.reports.shipment.list(params)
    }
  }
}
</script>
